import {RequestItemError} from './RequestItemError'
import {RequestError} from './RequestError'

export class ErrorResponseBody {
    requestError: RequestError
    requestItemErrors: RequestItemError[]

    constructor(requestError: RequestError, requestItemErrors: RequestItemError[]) {
        this.requestError = requestError
        this.requestItemErrors = requestItemErrors
    }

    static from(json: any): ErrorResponseBody {
        return new ErrorResponseBody(
            RequestError.from(json),
            json.requestItemErrors
                .map((jsonRequestItemErrors: any) => RequestItemError.from(jsonRequestItemErrors)),
        )

    }
}
